import { createStore } from 'vuex'

import postcodesCsv from '@/assets/csv/CBS_pc4_2020_v1.csv';
import cobouwCsv from '@/assets/csv/verdozing - versie 2 - cobouw.csv';
import investicoCsv from '@/assets/csv/verdozing - versie 2 - Investico.csv';

export default createStore({
	state: {
		zipcodes: [],
		verdozing: [],
		cobouw: [],
		step: {}
	},
	mutations: {
		SAVE_POSTCODES (state, data) {
			state.zipcodes = data;
		}, 

		SAVE_VERDOZING (state, data) {
			state.verdozing = data;
		}, 

		SAVE_COBOUW(state, data) {
			state.cobouw = data;
		},

		UPDATE_STEP(state, data) {
			state.step = data;
		}
	},
	getters: {
		zipcodes: state => state.zipcodes,
		verdozing: state => state.verdozing,
		cobouw: state => state.cobouw,
		step: state => state.step
	},
	actions: {
		loadData ({ commit, state }) {
			return new Promise((resolve, reject) => { 
				// Promise.all([
				// 	csv(`${process.env.BASE_URL}assets/CBS_pc4_2020_v1.csv`),
				// 	csv(`${process.env.BASE_URL}assets/verdozing - versie 2 - cobouw.csv`),
				// 	csv(`${process.env.BASE_URL}assets/verdozing - versie 2 - Investico.csv`)
				// ])
				// 	.then(([postcodes, cobouw, nieuwe]) => {
						commit("SAVE_POSTCODES", postcodesCsv);
						commit("SAVE_VERDOZING", investicoCsv);
						commit("SAVE_COBOUW", cobouwCsv);
						resolve();
					// })
					// .catch(error => {
					// 	reject();
					// 	throw new Error(`API ${error}`);
					// });
			})
		},

    updateStep({commit}, step) {
      commit("UPDATE_STEP", step);
    },

	},
	modules: {

	}
})
